import { Record } from 'immutable';

const LegalEntitySearchRecord = Record({
  code: null,
  chain: null,
  brand: null,
  propertyId: null,
});

export class LegalEntitySearch extends LegalEntitySearchRecord {
  code: string;
  chain: string;
  brand: string;
  propertyId: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/legal-entity-search.ts